export const h = {
    "common": {
        "webSuffix": "- QIDI Tech 치디 테크놀로지",
        "email": "메일박스",
        "password": "암호",
        "verificationCode": "인증 코드",
        "username": "사용자 이름",
        "readAndAgree": "동의합니다",
        "and": "및",
        "userAgreement": "사용자 프로토콜",
        "privacyPolicy": "개인 정보 보호 정책",
        "copy": "저작권 소유© 2025년부터 디 소유권 유지",
        "sendVerificationCode": "인증 코드 보내기",
        "Sending": "발송 중",
        "tryAgainInSeconds": "초 후 재시도",
        "userNameRequired": "사용자 이름을 입력하십시오.",
        "passwordInputLabel": "암호를 입력하십시오.",
        "checkPasswordInputLabel": "확인 암호를 입력하십시오.",
        "userEmailRequired": "이메일 주소를 입력하십시오.",
        "userEmailInvalid": "올바른 이메일 주소를 입력하십시오.",
        "emailCodeRequired": "인증 코드를 입력하십시오.",
        "newPasswordInputLabel": "새 암호를 입력하십시오.",
        "confirmPasswordInputLabel": "암호를 다시 입력하십시오.",
        "passwordMismatchErrorLabel": "두 번 입력한 암호가 일치하지 않습니다.",
        "agreementRequired": "계약서를 읽고 동의하십시오.",
        "tip": "힌트",
        "tipAlreadyLogin": "로그인이 감지되어 사용자 센터로 이동",
        "tipWelcomeBack": "어서 오세요 ~",
        "tipDeleteAccountFail": "계정 삭제 실패, 계정 삭제 인터페이스 일시 폐쇄 중",
        "pleaseAgreeFirst": "먼저 동의하십시오",
        "agree": "동의",
        "refuse": "거부",
        "tipNeedLogin": "먼저 로그인하십시오.",
        "tipChangePasswordSuccess": "암호를 수정하여 로그인 페이지로 이동했습니다.",
        "tipGetUserInfoSuccess": "정보 얻기 성공",
        "tipGetUserInfoFail": "정보 가져오기 실패",
        "tipLoginOut": "로그인 종료",
        "delete": "삭제",
        "back": "반환",
        "init": "초기화",

        "passwordInputLengthErrorLabel": "비밀번호 길이는 6 ~ 20 사이여야 합니다.",
        "changePasswordFail": "원래 암호 오류",
        "tipDeleteAccountSuccess": "계정 삭제 성공",
        "emailCodeSentSuccess": "인증 코드가 발송되었습니다.",
        "emailCodeSentFail": "인증 코드 발송 실패",
        "emailLoginFail": "유효성 검사 코드가 만료되었습니다.",
        "passwordLoginFail": "로그인 암호 오류",
        "editUserInfoSuccess": "사용자 정보를 수정했습니다.",
        "registerSuccess": "등록 성공",
        "registerFail": "등록 실패",
        "registerEmailExistFail": "메일박스 이미 있음",

        "resMessageTip0": "알 수 없는 정보",
        "resMessageTip1": "암호 오류",
        "resMessageTip2": "비밀번호 길이는 6 ~ 20 사이여야 합니다.",
        "resMessageTip3": "계정 오류",
        "resMessageTip4": "인증 코드가 발송되었습니다.",
        "resMessageTip5": "인증 코드 발송 실패",
        "resMessageTip6": "유효성 검사 코드가 만료되었습니다.",
        "resMessageTip7": "암호 오류",
        "resMessageTip8": "암호는 이전 암호와 같을 수 없습니다.",
        "resMessageTip9": "메일박스 이미 있음",
        "resMessageTip10": "등록 성공",
        "resMessageTip11": "등록 실패",
        "resMessageTip12": "사용자 정보를 수정했습니다.",
        "resMessageTip13": "사용자 정보 수정 실패",
        "resMessageTip14": "성공",
        "resMessageTip15": "가져오기 실패",
        "resMessageTip16": "암호 수정 성공",
        "resMessageTip17": "암호 수정 실패",
        "resMessageTip18": "암호 재설정 성공",
        "resMessageTip19": "암호 재설정 실패",
        "resMessageTip20": "로그인 성공",
        "resMessageTip21": "로그인 실패",
        "resMessageTip22": "계정 삭제 성공",
        "resMessageTip23": "계정 삭제 실패",
        "resMessageTip24": "인증 코드가 잘못되었습니다.",
        "noUserInfoError": "네트워크 오류, 다시 로그인하십시오."
    },
    "changePassword": {
        "newPassword": "새 암호"
    },
    "deleteUser": {
        "tipDeleteUser": "떠나게 되어 유감입니다.계정이 삭제되면 모든 개인 데이터가 영구적으로 사라지고 복구할 수 없습니다.",
        "accountDeletionTerms": "계정 삭제 조항"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "사서함으로 비밀번호 찾기",
        "confirmPassword": "암호 확인",
        "resettingPassword": "비밀번호 재설정",
        "resetting": "재설정"
    },
    "login": {
        "passwordLogin": "비밀번호 로그인",
        "verifyLogin": "로그인 확인",
        "accountRegistration": "계정 등록",
        "forgotPassword": "암호를 잊었습니다.",
        "login": "로그인",
        "localLogin": "로컬 로그인",
        "loginOut": "로그아웃",
        "continueOnYourWay": "계속 가"
    },
    "register": {
        "registerAnAccount": "계정 등록",
        "register": "등록"
    },
    "userCenter": {
        "personalInformation": "프로필",
        "modifyInformation": "정보 수정",
        "changePassword": "암호 수정",
        "cancelAccount": "계정 로그아웃",
        "exitAccount": "계정 탈퇴",
        "change": "수정",
        "maxCharLimitTip": "사용자 이름은 10자를 초과할 수 없습니다.",
    },
    "policies": {
        "deleteAccountPrivacy": "계정 프로토콜 삭제",
        "agreement": "프로토콜 사용",
        "privacyPolicy": "개인 정보 보호 정책"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "국가 또는 지역을 선택하십시오.",
        "recommendedVisits": "추천 방문",
        "NorthAmerica": "북아메리카",
        "Europe": "유럽",
        "Asia": "아시아",
        "Other": "기타",
    }
}
export const aAndL ={
    "ar": {
        "Country": "아랍",
        "Language": "아랍어"
    },
    "cs": {
        "Country": "체코",
        "Language": "체코어"
    },
    "de": {
        "Country": "독일",
        "Language": "독일어"
    },
    "en": {
        "Country": "영국",
        "Language": "영어"
    },
    "es": {
        "Country": "스페인",
        "Language": "스페인어"
    },
    "fr": {
        "Country": "프랑스",
        "Language": "프랑스어"
    },
    "he": {
        "Country": "이스라엘",
        "Language": "히브리어"
    },
    "hu": {
        "Country": "헝가리",
        "Language": "헝가리어"
    },
    "it": {
        "Country": "이탈리아",
        "Language": "이탈리아어"
    },
    "ja": {
        "Country": "일본",
        "Language": "일본어"
    },
    "ko": {
        "Country": "한국",
        "Language": "한국어"
    },
    "nl": {
        "Country": "네덜란드",
        "Language": "네덜란드어"
    },
    "pt": {
        "Country": "포르투갈",
        "Language": "포르투갈어"
    },
    "pt_BR": {
        "Country": "포르투갈 (브라질)",
        "Language": "포르투갈어 (브라질)"
    },
    "ru": {
        "Country": "러시아",
        "Language": "러시아어"
    },
    "sv": {
        "Country": "스웨덴",
        "Language": "스웨덴어"
    },
    "tr": {
        "Country": "터키",
        "Language": "터키어"
    },
    "uk": {
        "Country": "우크라이나",
        "Language": "우크라이나어"
    },
    "zh": {
        "Country": "중국 대륙",
        "Language": "중국어 간체"
    },
    "zh_tw": {
        "Country": "중국 대만",
        "Language": "중국어 번체"
    },
    "Canada": {
        "Country": "캐나다",
        "Language": "영어"
    },
    "United_States": {
        "Country": "미국",
        "Language": "영어"
    },
    "United_Kingdom": {
        "Country": "영국",
        "Language": "영어"
    },
    "EU_Countries": {
        "Country": "유럽 연합 국가",
        "Language": "영어"
    },
    "Australia": {
        "Country": "호주",
        "Language": "영어"
    },
    "globalzh": {
        "Country": "글로벌",
        "Language": "중국어 간체"
    },
    "globalen": {
        "Country": "Global",
        "Language": "영어"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/ko.js